import React, { Fragment } from "react";
import { Col } from "react-bootstrap";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Field, formValueSelector } from "redux-form";
import { connect } from "react-redux";

import { DashedSeparator } from "MODULES/shared/components";
import { FormInput } from "MODULES/shared/components/Forms";
import AddressFields from "MODULES/shared/components/CommercialInvoice/Form/FormSections/AddressFields";
import Contact from "MODULES/shared/components/CommercialInvoice/Form/FormSections/Contact";
import {
  ADDRESS_FIELDS,
  CITY,
  COMPANY_ID,
  COMPANY_NAME,
  CONTACT_ID,
  COUNTRY,
  EMAIL,
  LINE1,
  NAME,
  PHONE,
  PHONE1,
  POSTAL_CODE,
  SHIP_TO_COMPANY_ADDRESS_ID,
  SHIP_TO_COMPANY_ID,
  SHIP_TO_CUSTOMER_ADDRESS_ID,
  SHIP_TO_TYPE,
  STATE
} from "APP_ROOT/constants";
import { CUSTOMER } from "MODULES/shared/components/ShippingSection/shippingTypes";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import api from "APP_ROOT/api";
import pojo from "LIB/pojos";
import { COMPANY } from "MODULES/PurchaseOrders/constants";
import { DROPSHIP } from "MODULES/SalesOrders/components/shared/FormSections/ShippingSection/shippingTypes";
import ShipToOther from "MODULES/shared/components/ShippingSection/ShipToOther";
import { PHYSICAL_ADDRESS } from "MODULES/companies/constants";
import RestrictedAddressWarning from "MODULES/shared/components/RestictedAddressWarning/RestrictedAddressWarning";
import { isEmpty } from "lodash";
import { shipToCountryIsNotUSA } from "../../../SalesOrders/helpers";
import FinalDestinationWarning from "./FinalDestinationWarning";

const FINAL_DESTINATION_ADDRESS = "final_destination_address";

export class FinalDestinationFields extends React.Component {
  state = { invalidCompany: false, sameAsAbove: false };

  get shipToCountryIsInvalid() {
    const { getField, shippingToAddress } = this.props;

    const fields = [SHIP_TO_TYPE, "ship_to_shipping_address"];
    const values = fields.reduce(
      (allValues, fieldName) => ({
        ...allValues,
        [fieldName]: getField(fieldName)
      }),
      {}
    );

    return shipToCountryIsNotUSA(values, shippingToAddress);
  }

  setFinalDestination = (setFieldValue, companyId, addressId, contactId) => {
    api.companies.show(companyId, "all_associations").then(({ data }) => {
      const address = data.physical_addresses.filter(
        a => a.id === Number(addressId)
      )[0];

      setFieldValue(`${FINAL_DESTINATION_ADDRESS}.${COMPANY_NAME}`)(data.name);
      if (address) {
        const { id: _id, company_name: _coName, ...fields } = address;

        Object.keys(fields).forEach(field =>
          setFieldValue(`${FINAL_DESTINATION_ADDRESS}.${field}`)(address[field])
        );
      }

      const contact = data.contacts.filter(
        c => c.id === parseFloat(contactId)
      )[0];

      const finalToCustomerTranslation = {
        name: NAME,
        [PHONE]: PHONE1,
        email: EMAIL
      };

      if (contact) {
        const fields = pojo(contact).pick(NAME, PHONE1, EMAIL);
        const phoneVal = fields[PHONE1] || data.phone;

        Object.keys(finalToCustomerTranslation).forEach(field => {
          if (field === PHONE) {
            setFieldValue("final_destination_phone")(phoneVal);
          } else {
            setFieldValue(`final_destination_${field}`)(
              fields[finalToCustomerTranslation[field]]
            );
          }
        });
      }
    });
  };

  setSameAsAbove = ev => {
    ev.preventDefault();
    const { getField, setFieldValue } = this.props;
    const shipToType = getField(SHIP_TO_TYPE);

    const sameAsAbove = this.state.sameAsAbove;
    this.setState({ sameAsAbove: !sameAsAbove });
    if (sameAsAbove) {
      ADDRESS_FIELDS.forEach(field =>
        setFieldValue(`${FINAL_DESTINATION_ADDRESS}.${field}`)("")
      );

      return;
    }

    if (shipToType === CUSTOMER) {
      const companyId = getField(COMPANY_ID);
      const contactId = getField(CONTACT_ID);
      const addressId = getField(SHIP_TO_CUSTOMER_ADDRESS_ID);

      if (companyId && addressId) {
        this.setFinalDestination(
          setFieldValue,
          companyId,
          addressId,
          contactId
        );
      } else if (
        companyId &&
        !isEmpty(getField([PHYSICAL_ADDRESS, LINE1].join(".")))
      ) {
        ADDRESS_FIELDS.forEach(f => {
          setFieldValue(`${FINAL_DESTINATION_ADDRESS}.${f}`)(
            getField(`${PHYSICAL_ADDRESS}.${f}`)
          );
        });
      }
    }

    if (shipToType === COMPANY) {
      const companyId = getField(SHIP_TO_COMPANY_ID);
      const addressId = getField(SHIP_TO_COMPANY_ADDRESS_ID);

      this.setFinalDestination(setFieldValue, companyId, addressId);
    }

    if (shipToType === DROPSHIP) {
      ADDRESS_FIELDS.forEach(field =>
        setFieldValue(`${FINAL_DESTINATION_ADDRESS}.${field}`)(
          getField(`ship_to_shipping_address.${field}`)
        )
      );
    }
  };

  render() {
    const { getField, formName, showWarning } = this.props;

    const finalDestinationCountry = getField(
      `${FINAL_DESTINATION_ADDRESS}.${COUNTRY}`
    );

    const addressFields = [LINE1, CITY, STATE, POSTAL_CODE, COUNTRY].reduce(
      (final, f) => ({
        ...final,
        [f]: getField(`${FINAL_DESTINATION_ADDRESS}.${f}`)
      }),
      {}
    );

    return (
      <Fragment>
        {this.shipToCountryIsInvalid &&
          showWarning && (
            <Fragment>
              <FinalDestinationWarning />
              <DashedSeparator />
            </Fragment>
          )}
        <h4>
          Final Destination{" "}
          <button
            style={{ marginLeft: 10 }}
            className={classNames("btn btn-success btn-sm", {
              "btn-hollow": !this.state.sameAsAbove
            })}
            onClick={this.setSameAsAbove}
          >
            Same As Above
          </button>
        </h4>
        {getField(SHIP_TO_TYPE) === DROPSHIP ? (
          <ShipToOther section={FINAL_DESTINATION_ADDRESS} />
        ) : (
          <AddressFields
            path={FINAL_DESTINATION_ADDRESS}
            formName={formName}
            country={finalDestinationCountry}
            addCompanyName
          />
        )}

        <Contact path="final_destination" />
        <FormRow>
          <Col md={3}>
            <Field
              name="final_destination_reference"
              label="Ref#"
              component={FormInput}
            />
          </Col>
        </FormRow>
        <FormRow>
          <Col md={12}>
            <RestrictedAddressWarning {...addressFields} />
          </Col>
        </FormRow>
      </Fragment>
    );
  }
}

FinalDestinationFields.propTypes = {
  formName: PropTypes.string.isRequired,
  showWarning: PropTypes.bool,
  getField: PropTypes.func,
  setFieldValue: PropTypes.func,
  shippingToAddress: PropTypes.shape({
    country: PropTypes.string
  })
};

FinalDestinationFields.defaultProps = {
  getField: () => null,
  shippingToAddress: {
    country: ""
  },
  showWarning: false
};

export default connect(
  (state, props) => {
    const selector = formValueSelector(props.formName);

    return {
      getField: field => selector(state, field)
    };
  },
  (dispatch, props) => ({
    setFieldValue: field => val => props.change(field, val)
  })
)(FinalDestinationFields);



// WEBPACK FOOTER //
// ./app/modules/shared/components/FinalDestination/FinalDestinationFields.jsx